import { Component, OnInit } from '@angular/core';
import { ResourceService } from 'src/app/services/common/resource.service';

@Component({
  selector: 'app-privacy-policy-page',
  templateUrl: './privacy-policy-page.component.html',
  styleUrls: ['./privacy-policy-page.component.scss']
})
export class PrivacyPolicyPageComponent implements OnInit {

  resource: any = {};
  constructor(private resourceService: ResourceService) { }

  ngOnInit(): void {
    this.loadResoruce();
    this.resourceService.languageSubject.subscribe(response => {
      this.resource = response;
    });
  }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(
      response => {
        this.resource = response;
      });
  }
}
